<template>
    <div>
       <div id="page">
            <Header></Header>
        <div class="user01">
            <div class="user01-hd">
                <div class="user01-hd-head"><img :src="downPath + info.avatar" alt=""></div>
                <div class="user01-hd-txt">
                    <div class="user01-hd-name">{{ info.nickname }}</div>
                    <div class="user01-hd-info">平台等级：{{ gradeList[info.user_grade] }}</div>
                    <div class="user01-hd-info">房源数量：{{ info.total_house }}</div>
                    <div class="user01-hd-info2">
                        <span v-if="info.qualification_certificate != null"><img :src="downPath + info.qualification_certificate" alt=""></span>
                        <span v-if="info.business_license != null"><img :src="downPath + info.business_license" alt=""></span>
                    </div>
                    <telConfirm class="user01-hd-tel" :tel="info.re_mobile400" :note="info.mobile400"></telConfirm>
                    <div class="keep" v-if="info.isfocus == 0" @click="addFocus">关注</div>
                    <div class="keep" v-else-if="info.isfocus == 1" @click="delFocus">已关注</div>
                </div>
            </div>
            <div class="user01-desc">{{ info.introduction }}</div>
        </div>

        <div class="tabsw01">
            <div class="item" :class="{active: tabActive === 1}" @click="tabActive = 1">TA的房源</div>
            <div class="item" :class="{active: tabActive === 2}" @click="tabActive = 2">TA的攻略</div>
        <!--    <div class="item" :class="{active: tabActive === 3}" @click="tabActive = 3">TA的问答</div> -->
        </div>
        <van-list
                v-show="tabActive === 1"
                v-model="house.loading"
                :finished="house.finished"
                finished-text="没有更多了"
                @load="onLoad('getHouseList')">
            <div class="listw01-item" v-for="item in house.list">
                <div class="listw01-item-pic"><img :src="item.main_img" alt=""></div>
                <div class="listw01-item-txt">
                    <router-link :to="{path: 'house', query: {id: item.house_id}}">
                        <div class="listw01-item-name">{{ item.house_name }}</div>
                        <div class="listw01-item-info"><div class="lab">地址：</div><div class="val">{{ item.address }}</div></div>
                        <div class="listw01-item-info"><div class="lab">面积：</div><div class="val">{{ item.area }}㎡</div></div>
                        <div class="listw01-item-price">价格：{{ item.rent_sale_price }}元/㎡</div>
                        <div class="listw01-item-tags"><span>产业园</span><span>在售</span><span>软件服务与外包</span></div>
                    </router-link>
                    <telConfirm class="listw01-item-tel" :tel="item.re_mobile400"  :note="item.mobile400"></telConfirm>
<!--                    <a class="listw01-item-tel" :href="'tel:'+item.contact_mobile"></a>-->
                </div>
            </div>
        </van-list>
        <van-list
                v-show="tabActive === 2"
                v-model="strategy.loading"
                :finished="strategy.finished"
                finished-text="没有更多了"
                @load="onLoad">
            <router-link :to="{path: 'detailStrategy', query: {id: item.strategy_id}}" class="listw02-item" v-for="item in strategy.list">
                <div class="listw02-item-pic" v-if="item.strategy_thumbnail!=null"><img :src="item.strategy_thumbnail" alt=""></div>
                <div class="listw02-item-txt">
                    <div class="listw02-item-name">{{ item.title }}</div>
                    <div class="listw02-item-info"><span>{{ item.author }}</span><span>{{ item.re_create_time }}</span></div>
                    <div class="listw02-item-desc">{{ item.description }}</div>
                </div>
            </router-link>
        </van-list>
        <van-list
                v-show="tabActive === 3"
                v-model="question.loading"
                :finished="question.finished"
                finished-text="没有更多了"
                @load="onLoad">
            <router-link :to="{path: 'questionDetail', query: {sn: item.sn}}" class="listw03-item" v-for="item in question.list">
                <div class="listw03-item-name">{{ item.title }}</div>
                <div class="listw03-item-info">
                    <span class="msg">{{ item.number }}条回答</span>
                    <span class="keep">收藏</span>
                    <span class="share">分享</span>
                    <span class="date">{{ item.re_create_time }}</span>
                </div>
            </router-link>
        </van-list>
       </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import telConfirm from '@/components/TelConfirm'
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import { List, Toast } from 'vant';
    export default {
        name: "DetailUser",
        data: function () {
            return {
                tabActive: 1,
                sn: '',
                gradeList: {
                    'guwen': '选址顾问',
                    'daren': '选址达人',
                    'jingying': '选址精英',
                    'zhuanjia': '选址专家'
                },
                downPath: this.api.downPath,
                info: {member_id: ''},
                house: {
                    loading: false,
                    finished: false,
                    page: 1,
                    list: []
                },
                strategy: {
                    loading: false,
                    finished: false,
                    page: 1,
                    list: []
                },
                question: {
                    loading: false,
                    finished: false,
                    page: 1,
                    list: []
                }
            }
        },
        components: {
            Header, Footer, telConfirm,
            [List.name]: List,
            [Toast.name]: Toast
        },
        mounted(){
            this.sn = this.$route.query.sn;
            this.getView();
        },
        methods: {
            getView(){
                const _this = this;
                _this.api.getAgentView({sn: _this.sn}).then(function(response){
                    response.member_info.re_mobile400 = response.member_info.mobile400.split('转')[0];
                    _this.info = response.member_info;
                    _this.getHouseList();
                })
            },
            getHouseList(){
                const _this = this;
                _this.api.getAgentHouseList({
                    page: _this.house.page,
                    pageSize: 20,
                    creator_id: _this.info.member_id
                }).then(function(response){
                    if (response.house_list.length < 10) {
                        _this.house.finished = true
                    }
                    _this.house.loading = false;
                    _this.house.page++;
                    for (let i in response.house_list) {
                        let arr = response.house_list[i].mobile400.split('转');
                        response.house_list[i].re_mobile400 = arr[0];
                    }
                    if (_this.house.list.length == 0) {
                        _this.house.list = _this.house.list.concat(response.house_list)
                    } else if (_this.house.list[_this.house.list.length-1].house_id != response.house_list[response.house_list.length - 1].house_id) {
                        _this.house.list = _this.house.list.concat(response.house_list)
                    }
                })
            },
            getAgentStrategyList(){
                const _this = this;
                _this.api.getAgentStrategyList({
                    page: _this.strategy.page,
                    pageSize: 20,
                    creator_id: _this.info.member_id
                }).then(function(response){
                    if (response.strategy_list.length < 10) {
                        _this.strategy.finished = true
                    }
                    _this.strategy.loading = false;
                    _this.strategy.page++;
                    for (let i in response.strategy_list) {
                        response.strategy_list[i].re_create_time = _this.formatTime(response.strategy_list[i].create_time, '{y}-{m}-{d}');
                    }
                    if (_this.strategy.list.length == 0) {
                        _this.strategy.list = _this.strategy.list.concat(response.strategy_list)
                    } else if (_this.strategy.list[_this.strategy.list.length-1].strategy_id != response.strategy_list[response.strategy_list.length - 1].strategy_id) {
                        _this.strategy.list = _this.strategy.list.concat(response.strategy_list)
                    }
                })
            },
            getAgentQuestionList(){
                const _this = this;
                _this.api.getAgentQuestionList({
                    page: _this.question.page,
                    pageSize: 20,
                    creator_id: _this.info.member_id
                }).then(function(response){
                    if (response.question_list.length < 10) {
                        _this.question.finished = true
                    }
                    _this.question.loading = false;
                    _this.question.page++;
                    for (let i in response.strategy_list) {
                        response.strategy_list[i].re_create_time = _this.formatTime(response.strategy_list[i].create_time, '{y}-{m}-{d}');
                    }
                    if (_this.question.list.length == 0) {
                        _this.question.list = _this.question.list.concat(response.question_list)
                    } else if (_this.question.list[_this.question.list.length-1].question_id != response.question_list[response.question_list.length - 1].question_id) {
                        _this.question.list = _this.question.list.concat(response.question_list)
                    }
                })
            },
            addFocus(){
                const _this = this;
                let params = new FormData();
                params.append('member_id', _this.info.member_id);
                _this.api.addFocus(params).then(function(response){
                    Toast(response.msg);
                    _this.getView();
                })
            },
            delFocus(){
                const _this = this;
                let params = new FormData();
                params.append('focus_id', _this.info.focus_id);
                _this.api.delFocus(params).then(function(response){
                    Toast(response.msg);
                    _this.getView();
                })
            },
            onLoad(fnName){
                setTimeout(()=>{
                    this[fnName]()
                }, 500)
            }
        },
        watch: {
            tabActive(newVal){
                switch (newVal) {
                    case 1:
                        this.getHouseList();
                        break;
                    case 2:
                        this.getAgentStrategyList();
                        break;
                    case 3:
                        this.getAgentQuestionList();
                        break;
                }
            }
        }
    }
</script>

<style scoped>
    .listw03-item:first-child {margin-top: .2rem;}
    .listw02-item-name {white-space: nowrap;overflow: hidden;text-overflow: ellipsis;display: block;-webkit-box-orient: initial;-webkit-line-clamp: initial}
    .listw02-item-info {font-size: .2rem;margin-bottom: .1rem;}
    .listw02-item-desc {font-size: .24rem;color: #666;-webkit-line-clamp: 2;display: -webkit-box;-webkit-box-orient: vertical;overflow: hidden;}
    /deep/ .van-list {min-height: calc(100vh - 6.44rem);}
</style>